export var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["DELETE"] = "DELETE";
})(HttpMethod || (HttpMethod = {}));
/* global fetch */
export const fetchData = async (url, init) => {
    const meta = await fetch(url, init);
    const metadata = {
        status: meta.status,
        statusText: meta.statusText,
        responseType: meta.type,
        requestURL: meta.url,
        contentType: meta.headers.get('Content-Type'),
        contentLength: meta.headers.get('Content-Length')
    };
    const data = metadata.contentLength &&
        Number.parseInt(metadata.contentLength, 10) &&
        metadata.contentType &&
        metadata.contentType === 'application/json'
        ? meta.json()
        : meta.text();
    const result = {
        data,
        metadata
    };
    return result;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmV0Y2gtZGF0YS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvZmV0Y2gtZGF0YS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnQkEsTUFBTSxDQUFOLElBQVksVUFNWDtBQU5ELFdBQVksVUFBVTtJQUNwQix5QkFBVyxDQUFBO0lBQ1gsMkJBQWEsQ0FBQTtJQUNiLHlCQUFXLENBQUE7SUFDWCw2QkFBZSxDQUFBO0lBQ2YsK0JBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQU5XLFVBQVUsS0FBVixVQUFVLFFBTXJCO0FBUUQsa0JBQWtCO0FBRWxCLE1BQU0sQ0FBQyxNQUFNLFNBQVMsR0FBRyxLQUFLLEVBQzVCLEdBQVcsRUFDWCxJQUFpQixFQUNFLEVBQUU7SUFDckIsTUFBTSxJQUFJLEdBQUcsTUFBTSxLQUFLLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxDQUFDO0lBQ3BDLE1BQU0sUUFBUSxHQUFHO1FBQ2YsTUFBTSxFQUFFLElBQUksQ0FBQyxNQUFNO1FBQ25CLFVBQVUsRUFBRSxJQUFJLENBQUMsVUFBVTtRQUMzQixZQUFZLEVBQUUsSUFBSSxDQUFDLElBQUk7UUFDdkIsVUFBVSxFQUFFLElBQUksQ0FBQyxHQUFHO1FBQ3BCLFdBQVcsRUFBRSxJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxjQUFjLENBQUM7UUFDN0MsYUFBYSxFQUFFLElBQUksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLGdCQUFnQixDQUFDO0tBQ2xELENBQUM7SUFDRixNQUFNLElBQUksR0FDUixRQUFRLENBQUMsYUFBYTtRQUN0QixNQUFNLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQyxhQUFhLEVBQUUsRUFBRSxDQUFDO1FBQzNDLFFBQVEsQ0FBQyxXQUFXO1FBQ3BCLFFBQVEsQ0FBQyxXQUFXLEtBQUssa0JBQWtCO1FBQ3pDLENBQUMsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFO1FBQ2IsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztJQUVsQixNQUFNLE1BQU0sR0FBYTtRQUN2QixJQUFJO1FBQ0osUUFBUTtLQUNULENBQUM7SUFFRixPQUFPLE1BQU0sQ0FBQztBQUNoQixDQUFDLENBQUMifQ==